import HomePage from 'pages/home';
import CoursesPage from 'pages/home/Courses';
import WebinarsPage from 'pages/home/webinars';
import ExpertOpinion from 'pages/expertOpinion';
import Reviews from 'pages/home/Reviews';
import Olympiads from 'pages/home/olympiads';
import KnowledgeMonitoring from 'pages/home/monitoring';
import Schools from 'pages/home/schools';
import LoginPage from 'pages/Auth';
import Gratitudes from 'pages/home/Gratitudes';
import Updates from 'pages/home/Updates';
import Surveys from 'pages/home/Surveys';
import { Error404Page, Error500Page } from 'pages/error';
import MainPage from 'pages/home/mainPage';
import PdfViewPage from 'pages/unauthorized/PdfView';
import FAQ from '../../pages/home/FAQ';

export const accountRoutes = [
  {
    path: '/',
    component: HomePage,
    exact: true,
  },
  {
    path: '/main',
    component: MainPage,
    exact: true,
  },
  {
    path: '/courses',
    component: CoursesPage,
    exact: true,
  },
  {
    path: '/webinars',
    component: WebinarsPage,
    exact: true,
  },
  {
    path: '/olympiads',
    component: Olympiads,
    exact: true,
  },
  {
    path: '/knowledge_slices',
    component: KnowledgeMonitoring,
    exact: true,
  },
  {
    path: '/schools',
    component: Schools,
    exact: true,
  },
  {
    path: '/expert_opinion',
    component: ExpertOpinion,
    exact: true,
  },
  // {
  //   path: '/reviews',
  //   component: Reviews,
  // },
  {
    path: '/surveys',
    component: Surveys,
  },
  {
    path: '/faq',
    component: FAQ,
  },
  {
    path: '/gratitude',
    component: Gratitudes,
  },
  {
    path: '/updates',
    component: Updates,
  },
  {
    path: '/cabinetmunicipaliteta/:subject_id/memo',
    component: PdfViewPage,
  },
  {
    path: '/login',
    component: LoginPage,
    exact: true,
  },
  {
    path: '/500',
    component: Error500Page,
    exact: true,
  },
  {
    component: Error404Page,
  },
];
